import { Button, ActionIcon, Menu, Group, Tooltip, useMantineColorScheme } from "@mantine/core";
import { Settings, ChevronDown, Info, Edit, Trash } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";

export interface TabGroupActionsButtonProps {
    setIsDetailsOpen: (open: boolean) => void;
    setIsDeleteModalOpen: (open: boolean) => void;
}

export function TabGroupActionsButton({
    setIsDetailsOpen,
    setIsDeleteModalOpen,
}: TabGroupActionsButtonProps) {
    const navigate = useNavigate();
    const { colorScheme } = useMantineColorScheme();
    const { id: tabGroupId } = useParams<{ id: string }>();

    return (
        <Group gap="xs">
            <Menu shadow="md" width={200} position="bottom-end">
                <Menu.Target>
                    <Group gap={0}>
                        <Button
                            visibleFrom="sm"
                            color="black"
                            c="white"
                            leftSection={<Settings size={16} />}
                            rightSection={<ChevronDown size={14} />}
                        >
                            Actions
                        </Button>
                        <Tooltip label="Actions">
                            <ActionIcon
                                hiddenFrom="sm"
                                variant="filled"
                                color="black"
                                c="white"
                                size="lg"
                            >
                                <Settings size={20} />
                            </ActionIcon>
                        </Tooltip>
                    </Group>
                </Menu.Target>
                <Menu.Dropdown
                    style={{
                        backgroundColor: colorScheme === 'dark' ? 'var(--modal-bg)' : undefined,
                        borderColor: colorScheme === 'dark' ? 'var(--modal-border)' : undefined,
                        backdropFilter: 'blur(var(--modal-blur))'
                    }}
                >
                    <Menu.Item leftSection={<Info size={16} />} onClick={() => setIsDetailsOpen(true)}>View Details</Menu.Item>
                    <Menu.Divider />
                    <Menu.Item leftSection={<Edit size={16} />} onClick={() => navigate(`/tab-groups/${tabGroupId}/edit`)}>Edit</Menu.Item>
                    <Menu.Item color="red" leftSection={<Trash size={16} />} onClick={() => setIsDeleteModalOpen(true)}>Delete</Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </Group >
    );
}
